import { apiRequest } from "../util/apiUtils";

export const addOneTimePayment = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `payment-gateway/create-checkout
`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const addMonthlyPayment = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `payment-gateway/create-subscription-checkout
`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentMethodList = async (params) => {
  try {
    const res = await apiRequest("get", `paymentmethod/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const paymentSuccess = async (params) => {
  try {
    const res = await apiRequest("post", `payment/complete-successfull`, {
      body: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
}

export const cardList = async () => {
  try {
    const res = await apiRequest("get", 'payment/stripe/card-list');
    return res?.data;
  } catch (err) {
    throw err;
  }
}